import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import Authenticated from "@/Layouts/Authenticated";
import { Link } from "@inertiajs/inertia-react";
import { DocumentAddIcon, PlusSmIcon } from "@heroicons/react/outline";
import PageHeading from "@/Components/PageHeading";

import DataTables from "datatables.net/js/jquery.dataTables.min";
import "datatables.net-responsive";

const Index = () => {
    const breadcrumb = [
        { name: "Dashboard", route: route("dashboard") },
        { name: "Student", route: route("students") },
    ];

    const studentTable = useRef(null);

    const [datatable, setDatatable] = useState(null);

    useEffect(() => {
        setDatatable(
            new DataTables(studentTable.current, {
                processing: true,
                serverSide: true,
                retrieve: true,
                responsive: true,
                autoWidth: false,
                searchDelay: 1000,
                ajax: `${route("students.datatable")}`,
                pageLength: 50,
                orderMulti: false,
                dom: "<'dt-header'lf>t<'dt-footer'ip>",
                language: {
                    lengthMenu: "Show Entries _MENU_",
                },
                columns: [
                    {
                        name: "id",
                        orderable: false,
                        searchable: false,
                        className: "dt-tr-first",
                        defaultContent: "",
                        render: function (data, type, row, meta) {
                            return meta.row + meta.settings._iDisplayStart + 1;
                        },
                    },
                    {
                        data: "registration_no",
                        name: "registration_no",
                        className: "dt-tr",
                    },
                    {
                        data: "name",
                        name: "name",
                        className: "dt-tr",
                    },
                    {
                        data: "contact",
                        name: "contact",
                        className: "dt-tr",
                    },
                    {
                        data: "identification_no",
                        name: "identification_no",
                        className: "dt-tr",
                    },
                    {
                        data: "dob",
                        name: "dob",
                        className: "dt-tr",
                    },
                    {
                        responsivePriority: "-1",
                        defaultContent: "-",
                        orderable: false,
                        searchable: false,
                        createdCell: function (
                            td,
                            cellData,
                            rowData,
                            rowIndex,
                            colIndex
                        ) {
                            return ReactDOM.render(
                                <Link
                                    href={route("students.edit", rowData.id)}
                                    className="text-indigo-600 hover:text-indigo-900"
                                >
                                    Edit
                                </Link>,
                                td
                            );
                        },
                    },
                ],
            })
        );
    }, []);

    return (
        <div className="py-6">
            <PageHeading heading={"Students"} breadcrumb={breadcrumb}>
                <span>
                    <Link
                        className="btn-base btn-light"
                        href={route("students.create")}
                    >
                        <PlusSmIcon
                            className="-ml-1 mr-2 h-5 w-5 text-gray-500"
                            aria-hidden={true}
                        />
                        Add Student
                    </Link>
                </span>
                <span className={"ml-3"}>
                    <Link
                        className="btn-base btn-light"
                        href={route("students.import")}
                    >
                        <DocumentAddIcon
                            aria-hidden={true}
                            className="-ml-1 mr-2 h-5 w-5 text-gray-500"
                        />
                        Import
                    </Link>
                </span>
            </PageHeading>
            <div className="mt-8">
                <div className="flex flex-col">
                    <div
                        className={
                            "min-w-full py-2 align-middle sm:px-6 lg:px-8"
                        }
                    >
                        <div
                            className={
                                "min-w-full bg-white p-2 shadow sm:rounded-lg"
                            }
                        >
                            <table
                                id="datatable"
                                ref={studentTable}
                                className={
                                    "mt-2 min-w-full divide-y divide-gray-200"
                                }
                            >
                                <thead className={"bg-gray-50"}>
                                    <tr>
                                        <th scope={"col"} className={"dt-th"}>
                                            #ID
                                        </th>
                                        <th scope={"col"} className={"dt-th"}>
                                            Registration No
                                        </th>
                                        <th scope={"col"} className={"dt-th"}>
                                            Name
                                        </th>
                                        <th scope={"col"} className={"dt-th"}>
                                            Contact
                                        </th>
                                        <th scope={"col"} className={"dt-th"}>
                                            Identification No
                                        </th>
                                        <th scope={"col"} className={"dt-th"}>
                                            Date of Birth
                                        </th>
                                        <th
                                            scope={"col"}
                                            className={"relative px-6 py-3"}
                                        >
                                            <span className={"sr-only"}>
                                                Edit
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

Index.layout = (page) => <Authenticated title={"Student"} children={page} />;

export default Index;
